export const version = "networks/5.0.8";
//# sourceMappingURL=_version.js.map